import { render } from "./ContactListItem.vue?vue&type=template&id=1035234c"
import script from "./ContactListItem.vue?vue&type=script&lang=js"
export * from "./ContactListItem.vue?vue&type=script&lang=js"

import "./ContactListItem.vue?vue&type=style&index=0&id=1035234c&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__